import { FileExcelTwoTone } from "@ant-design/icons";

export const ExcelIcon = () => {
  return <FileExcelTwoTone twoToneColor="#28A475" />;
};
